import { render, staticRenderFns } from "./ImportPromotionalItemsFromExcel.vue?vue&type=template&id=3192e722&"
import script from "./ImportPromotionalItemsFromExcel.vue?vue&type=script&lang=js&"
export * from "./ImportPromotionalItemsFromExcel.vue?vue&type=script&lang=js&"
import style0 from "./ImportPromotionalItemsFromExcel.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports